<template>
    <div class="d-flex content-container h-100 overflow-hidden">
        <page-header
            :page-title="chapterName ? chapterName : ''"
            :page-icon="chapterIcon ? `/images/master-dashboard/${chapterIcon}_current.svg` : null"
            removeBackButton
        />
        <div v-if="isLoading" class="d-flex justify-content-center w-100 h-100 align-items-center">
            <b-spinner class="align-middle" variant="secondary" />
        </div>
        <div v-else class="d-flex content-container align-items-center w-100 overflow-hidden">
            <div class="container overflow-hidden">
                <div class="row">
                    <div class="col">
                        <h4 class="text-primary mb-3 mt-2">
                            {{title}}
                        </h4>
                        <p class="mb-2" v-html="description" />
                        <p class="font-weight-bold mb-2" v-if="subDescription" v-html="subDescription" />

                        <div class="mw-25-vw mx-auto">
                            <b-img :src="imgPath" alt="..." class="w-100" />
                        </div>
                        <div class="d-flex justify-content-end align-items-center">
                            <router-link v-if="secondaryCtaLink" :to="secondaryCtaLink" class="font-weight-bold text-secondary mr-4">{{secondaryCtaText}}</router-link>
                            <b-button variant="secondary" @click="doCompleteFunc" :disabled="loading">
                                <b-spinner small type="grow" v-if="loading"/>
                                {{ctaText}}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../organisms/PageHeader";
export default {
    components: {PageHeader},
    data(){
        return {
            loading: false
        }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        subDescription: {
            type: String,
            required: false
        },
        imgPath: {
            type: String,
            required: true
        },
        ctaText: {
            type: String,
            required: true
        },
        secondaryCtaLink: {
            type: String,
            required: false
        },
        secondaryCtaText: {
            type: String,
            required: false
        },
        chapterName: {
            type: String,
            required: false
        },
        chapterIcon: {
            type: String,
            required: false
        },
        isLoading: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        doCompleteFunc: function() {
            this.loading = true;
            this.$emit('onCompleted')
        }
    }
}
</script>
<style lang="scss" scoped>
.mw-25-vw {
    @media (min-width: 768px) {
        max-width:50vw;
    }
    @media (min-width: 992px) {
        max-width:25vw;
    }
}
</style>
